<!-- eslint-disable prettier/prettier -->
<template>
  <div>
    <div
      class="comanpy-select-wrapper"
      @click="openPopup"
    >
     <div class="company-name">{{ billName }}</div>
      <maple-icon class="arrow-down" size="0.24rem" name="down_filled1" />
    </div>
    <van-popup v-model="showType" round position="bottom">
      <div class="popup-wrapper">
        <div class="popup-title">
          选择时间
          <div class="close-btn" @click="closePopup">
            <IconFont
              name="guanbi"
              size=".24rem"
              color="#666"
              class="icon-font"
            ></IconFont>
          </div>
        </div>
        <scroll-view class="scroll-view-wrapper">
          <div
            v-for="item in billTypeList"
            :key="item.value"
            class="company-item"
            @click="select(item)"
          >
            <div class="select-operate">
              <IconFont
                :name="
                  selected_type == item.value
                    ? 'xuankuang-gouxuan'
                    : 'xuankuang-weixuanzhong'
                "
                :color="selected_type == item.value ? '#15bb5c' : '#CCCCCC'"
                size="20px"
              ></IconFont>
            </div>
            <div class="info">
              <div class="name-wrapper">
                <span class="name"> {{ item.name }}</span>
              </div>
            </div>
          </div>
        </scroll-view>
      </div>
    </van-popup>
  </div>
</template>

<script>
import ScrollView from '@/common/widgets/scroll_view'
export default {
  name: 'BillCompany',
  components: {
    ScrollView
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['page', 'billSelectType'],
  data() {
    return {
      billName: '发生时间',
      billTypeList: [
        {
          name: '发生时间',
          value: 1
        },
        {
          name: '完成时间',
          value: 2
        }
      ],
      showType: false,
      selected_type: 1
    }
  },
  created() {
    if (this.page === 'bill') {
      this.$emit('selectType', this.selected_type)
    } else {
      this.selected_type = this.billSelectType
      // eslint-disable-next-line camelcase
      const selectedItem = this.billTypeList.find(
        // eslint-disable-next-line eqeqeq
        item => item.value == this.billSelectType
      )
      // this.setBillSelectedCompanyId(selected_company_id)
      const name = selectedItem?.name
      // eslint-disable-next-line camelcase
      this.billName = name
      this.$emit('selectType', this.selected_type)
    }
  },
  methods: {
    openPopup() {
      this.showType = true
    },
    select(item) {
      if (this.page === 'bill') {
        if (item.value === 1) {
          this.$track(this.$trackMap.bill.indexOrderTimeClick)
        } else {
          this.$track(this.$trackMap.bill.indexDeliveryTimeClick)
        }
      } else {
        if (item.value === 1) {
          this.$track(this.$trackMap.bill.exportOrderTimeClick)
        } else {
          this.$track(this.$trackMap.bill.exportDeliveryTimeClick)
        }
      }

      this.selected_type = item.value
      this.billName = item.name
      this.showType = false
      this.$emit('selectType', item.value)
    },
    closePopup() {
      this.showType = false
    }
  }
}
</script>

<style lang="scss" scoped>
.comanpy-select-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 44px;
  padding-left: 0.4rem;
  padding-right: 0.46rem /* 23/50 */;
  background-color: #fff;
  .arrow-down {
    margin-left: 2px;
  }
  .company-name {
    @include text-overflow-ellipsis;
    @include text(0.28rem /* 14/50 */, #262626);
  }
}

.popup-wrapper {
  height: 80vh;
  display: flex;
  flex-direction: column;

  .popup-title {
    height: 1.04rem /* 52/50 */;
    position: relative;
    @include flex-row-center;
    @include text(0.32rem /* 16/50 */, #333333, true);
    .close-btn {
      width: 20px;
      height: 20px;
      position: absolute;
      right: 0.2rem /* 10/50 */;
      top: 50%;
      margin-top: -10px;
    }
  }
  .scroll-view-wrapper {
    flex: auto;
    height: 0;
    padding-bottom: 0.4rem /* 20/50 */;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
.company-item {
  @include flex-row-center;
  margin: 0 0.32rem /* 16/50 */;
  padding: 0.32rem /* 16/50 */ 0;
  /* 15/50 */
  background: #fff;
  box-sizing: border-box;
  border-bottom: 1px solid #f6f6f6;
  .company-tag {
    width: 26px;
    height: 14px;
    margin-right: 0.12rem /* 6/50 */;
  }

  .info {
    flex: auto;
    width: 0;
    margin-left: 0.24rem /* 12/50 */;
    .name-wrapper {
      @include flex(row, normal, center);
      .tag {
        width: 0.52rem /* 26/50 */;
        height: 0.28rem /* 14/50 */;
        margin-right: 0.12rem /* 6/50 */;
      }
      .name {
        @include text(0.28rem /* 14/50 */, #262626, true);
        @include text-overflow-ellipsis;
      }
    }

    .address {
      @include text(14px, #999999);
      @include text-overflow-ellipsis;
      margin-top: 0.18rem /* 9/50 */;
    }
  }
}
</style>
